var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-4 col-md-6 portfolio-item",class:_vm.filter},[_c('div',{staticClass:"portfolio-img"},[_c('p',{attrs:{"data-gallery":"portfolioGallery"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.image,"alt":""}})]),_c('div',{staticClass:"portfolio-info"},[_c('h4',[_vm._v(_vm._s(_vm.info))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }